<template>
  <o-section :title="label || schema.verbose_name" not-closable :level="level">
    <o-repeating-cards
      :list="items"
      @change="changed"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
    >
      <template slot-scope="props">
        <item-form
          :item-roles="itemRoles"
          :codeActivityTypeItems="codeActivityTypeItems"
          :item="items[props.index]"
          :server-errors="_se[props.index]"
          :form-state="formState"
          :level="level"
        ></item-form>
      </template>
    </o-repeating-cards>
  </o-section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../../vue-ocom/mixins";

import OSection from "../../../../vue-ocom/components/layout/OSection";
import ORepeatingCards from "../../../../vue-ocom/components/table/ORepeatingCards";

import ItemForm from "./ItemForm";

export default {
  name: "ProcessActivityFormCards",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("ProcessActivity"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OSection,
    ORepeatingCards,
    ItemForm,
  },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    itemRoles: { type: Array, default: () => [] },
    codeActivityTypeItems: { type: Array, default: () => [] },
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ProcessActivity,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.ProcessActivity),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>